import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../services/api';

const css = `
.fac-wrap{display:grid;grid-template-columns:1fr 400px;gap:14px;height:calc(100vh - 130px);}
.fac-lista{display:flex;flex-direction:column;background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;}
.fac-panel{background:var(--surface);border-radius:10px;border:1px solid var(--border);overflow:hidden;display:flex;flex-direction:column;}
.fac-hdr{padding:10px 16px;background:var(--navy);color:#fff;font-size:12px;font-weight:700;display:flex;align-items:center;justify-content:space-between;}
.fac-filters{padding:10px 14px;border-bottom:1px solid var(--border);display:flex;gap:8px;flex-wrap:wrap;align-items:flex-end;}
.fac-body{flex:1;overflow-y:auto;}
.fac-row{padding:9px 14px;border-bottom:1px solid var(--bg);cursor:pointer;display:grid;grid-template-columns:1fr auto;gap:3px;transition:background .1s;}
.fac-row:hover{background:var(--blue-lt);}
.fac-row.sel{background:var(--blue-lt);border-left:3px solid var(--navy);}
.fac-det-body{flex:1;overflow-y:auto;padding:14px;}
.fac-tbl{width:100%;border-collapse:collapse;font-size:11px;margin-bottom:10px;}
.fac-tbl th{background:#1a2535;color:#fff;padding:6px 8px;font-weight:600;text-align:left;}
.fac-tbl td{padding:5px 7px;border-bottom:1px solid var(--border);}
.fac-total{background:var(--navy);color:#fff;border-radius:8px;padding:10px 14px;display:grid;grid-template-columns:1fr auto;gap:3px;font-size:12px;}
.tab-btns{display:flex;border-bottom:1px solid var(--border);}
.tab-btn{padding:8px 16px;font-size:12px;cursor:pointer;border:none;background:transparent;border-bottom:2px solid transparent;font-weight:500;color:var(--text2);}
.tab-btn.on{border-bottom-color:var(--navy);color:var(--navy);font-weight:700;}
.mb{position:fixed;inset:0;background:rgba(0,0,0,.45);z-index:200;display:flex;align-items:center;justify-content:center;padding:16px;}
.mx{background:#fff;border-radius:10px;width:100%;max-width:680px;max-height:93vh;overflow-y:auto;box-shadow:0 10px 40px rgba(0,0,0,.25);}
.mh{padding:12px 18px;border-radius:10px 10px 0 0;display:flex;align-items:center;justify-content:space-between;}
.mbd{padding:16px;}
.mf{padding:10px 16px;border-top:1px solid var(--border);display:flex;gap:8px;justify-content:flex-end;}
.inp{width:100%;padding:5px 7px;font-size:12px;border:1px solid var(--border);border-radius:4px;}
`;

const ESTADOS = {
  ACT:{ label:'Activa',   bg:'#5BAD8F', fg:'#fff' },
  CNC:{ label:'Cancelada',bg:'#6C9BD2', fg:'#fff' },
  ANL:{ label:'Anulada',  bg:'#EF9A9A', fg:'#333' },
};

const fmt = v => `$${Number(v||0).toFixed(2)}`;

/* ── Modal Factura ──────────────────────────────────── */
function ModalFactura({ turno, cajas, formasPago, servicios, ivaGlobal=15, onGuardar, onCerrar }) {
  const [tab, setTab] = useState('productos');
  const [historial, setHistorial] = useState(null);
  const [loadingHist, setLoadingHist] = useState(false);
  const [histErr, setHistErr] = useState('');
  const [form, setForm] = useState({
    COD_CAJA:              cajas[0]?.COD || '',
    COD_PACIENTE:          turno?.COD_PACIENTE || '',
    C_TIPO_IDENTIFICACION: turno?.C_TIPO_IDENTIFICACION || 'CDL',
    IDENTIFICACION:        turno?.IDENTIFICACION || '',
    RAZON_SOCIAL:          turno ? `${turno.APELLIDO_PATERNO||''} ${turno.APELLIDO_MATERNO||''} ${turno.PRIMER_NOMBRE||''}`.trim() : '',
    DIRECCION:             turno?.DIRECCION || '',
    TELEFONO:              turno?.TELEFONO || '',
    EMAIL:                 turno?.EMAIL || '',
    OBSERVACION:           turno ? `TURNO #${turno.NUMERO} - ${turno.MEDICO}` : '',
  });
  const [detalles, setDetalles] = useState(
    turno ? [{
      DESCRIPCION:    turno.SERVICIO,
      CANTIDAD:       1,
      VALOR:          Number(turno.VALOR) || 0,
      DESCUENTO:      0,
      PORCENTAJE_IVA: turno.APLICA_IVA ? Number(turno.IVA_GLOBAL||turno.PORCENTAJE_IVA||0) : 0,
      COD_CONSUMO:    turno.COD_SERVICIO,
    }] : []
  );
  const [pagos,   setPagos]   = useState([]);
  const [saving,  setSaving]  = useState(false);
  const [err,     setErr]     = useState('');
  const [sriInfo, setSriInfo] = useState(null);
  const [pendientes,  setPendientes]  = useState([]);
  const [pendSel,     setPendSel]     = useState([]);
  const [consumosIds, setConsumosIds] = useState([]);
  const [cajaAbierta, setCajaAbierta] = useState(null); // null=cargando, true/false

  useEffect(() => {
    if (!form.COD_CAJA) { setCajaAbierta(null); return; }
    setCajaAbierta(null);
    api.get(`/facturacion/cierre-caja/estado?cod_caja=${form.COD_CAJA}`)
      .then(r => setCajaAbierta(!!r.data?.abierto))
      .catch(() => setCajaAbierta(null));
  }, [form.COD_CAJA]);

  // Si la lista de cajas llega después del render inicial (fetch async), sincronizar la selección
  useEffect(() => {
    if (!form.COD_CAJA && cajas.length > 0) {
      setForm(f => ({ ...f, COD_CAJA: cajas[0].COD }));
    }
  }, [cajas]);

  // Buscar paciente si no viene de turno
  const [busqPac, setBusqPac] = useState('');
  const [sugsPac, setSugsPac] = useState([]);
  const [perfilesFacturacion, setPerfilesFacturacion] = useState([]);
  const [modoFactura, setModoFactura] = useState('propio'); // 'propio' | COD del perfil | 'otro'
  const [datosPacienteOriginal, setDatosPacienteOriginal] = useState(null);

  useEffect(() => {
    if (busqPac.length < 2 || turno) { setSugsPac([]); return; }
    const t = setTimeout(async () => {
      try { const { data } = await api.get(`/pacientes?q=${encodeURIComponent(busqPac)}&limit=6`); setSugsPac(data); } catch {}
    }, 300);
    return () => clearTimeout(t);
  }, [busqPac, turno]);

  const selPac = p => {
    setSugsPac([]); setBusqPac('');
    const datosOriginales = {
      IDENTIFICACION: p.IDENTIFICACION,
      RAZON_SOCIAL: `${p.APELLIDO_PATERNO||''} ${p.APELLIDO_MATERNO||''} ${p.PRIMER_NOMBRE||''}`.trim(),
      TELEFONO: p.TELEFONO || '',
      EMAIL:    p.EMAIL    || '',
      C_TIPO_IDENTIFICACION: p.C_TIPO_IDENTIFICACION || 'CDL',
    };
    setDatosPacienteOriginal(datosOriginales);
    setModoFactura('propio');
    setForm(f => ({ ...f, COD_PACIENTE: p.COD, ...datosOriginales }));
  };

  const cambiarModoFactura = (valor) => {
    setModoFactura(valor);
    if (valor === 'propio' && datosPacienteOriginal) {
      setForm(f => ({ ...f, ...datosPacienteOriginal }));
    } else if (valor === 'otro') {
      setForm(f => ({ ...f, IDENTIFICACION:'', RAZON_SOCIAL:'', TELEFONO:'', EMAIL:'' }));
    } else {
      const perfil = perfilesFacturacion.find(pf => String(pf.COD) === String(valor));
      aplicarPerfilFacturacion(perfil);
    }
  };

  useEffect(() => {
    if (!form.COD_PACIENTE) { setPendientes([]); setPendSel([]); setPerfilesFacturacion([]); setModoFactura('propio'); return; }
    api.get(`/facturacion/consumos/${form.COD_PACIENTE}`)
      .then(r => { setPendientes(r.data||[]); setPendSel((r.data||[]).filter(p=>p.C_ESTADO==='PND').map(p=>p.COD)); })
      .catch(()=>setPendientes([]));
    api.get(`/pacientes/${form.COD_PACIENTE}/facturacion`)
      .then(r => setPerfilesFacturacion(r.data||[]))
      .catch(()=>setPerfilesFacturacion([]));
  }, [form.COD_PACIENTE]);

  // Anula un cargo pendiente (ej. el paciente no se hizo el examen aquí) —
  // nunca toca cargos ya facturados, esos se manejan con nota de crédito.
  const anularPendiente = async (cod) => {
    const motivo = window.prompt('Motivo de anulación (opcional):');
    if (motivo === null) return; // canceló el prompt
    try {
      await api.patch(`/facturacion/consumos/${cod}/anular`, { motivo });
      const r = await api.get(`/facturacion/consumos/${form.COD_PACIENTE}`);
      setPendientes(r.data||[]);
      setPendSel((r.data||[]).filter(p=>p.C_ESTADO==='PND').map(p=>p.COD));
    } catch(e) {
      alert(e.response?.data?.error || e.message);
    }
  };

  const aplicarPerfilFacturacion = (perfil) => {
    if (!perfil) return;
    setForm(f => ({
      ...f,
      IDENTIFICACION: perfil.IDENTIFICACION,
      RAZON_SOCIAL: `${perfil.APELLIDOS||''} ${perfil.NOMBRES||''}`.trim(),
      C_TIPO_IDENTIFICACION: perfil.C_TIPO_IDENTIFICACION || 'CDL',
      TELEFONO: perfil.TELEFONO || '',
      EMAIL: perfil.EMAIL || '',
    }));
  };

  const togglePend = cod => setPendSel(s => s.includes(cod) ? s.filter(x=>x!==cod) : [...s,cod]);

  const agregarPendientesSel = () => {
    const seleccionados = pendientes.filter(p => p.C_ESTADO==='PND' && pendSel.includes(p.COD) && !consumosIds.includes(p.COD));
    if (!seleccionados.length) return;
    setDetalles(d => [...d, ...seleccionados.map(p => ({
      DESCRIPCION:    p.DESCRIPCION||'Examen',
      CANTIDAD:       Number(p.CANTIDAD)||1,
      VALOR:          Number(p.VALOR)||0,
      DESCUENTO:      Number(p.DESCUENTO)||0,
      PORCENTAJE_IVA: Number(p.PORCENTAJE_IVA)||0,
      COD_CONSUMO:    p.COD_SERVICIO,
      _consumoId:     p.COD,
    }))]);
    setConsumosIds(ids => [...ids, ...seleccionados.map(p=>p.COD)]);
  };

  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const setD = (i,k,v) => setDetalles(d=>d.map((r,j)=>j===i?{...r,[k]:v}:r));
  const setP = (i,k,v) => setPagos(p=>p.map((r,j)=>j===i?{...r,[k]:v}:r));

  const verHistorial = async () => {
    setTab('historial');
    if (!form.COD_PACIENTE) return;
    if (historial!==null && !histErr) return;
    setLoadingHist(true); setHistErr('');
    try {
      const { data } = await api.get(`/facturacion/historial-paciente?cod_paciente=${form.COD_PACIENTE}`);
      setHistorial(data);
    } catch(e) { setHistErr(e.response?.data?.error || e.message); setHistorial([]); }
    setLoadingHist(false);
  };

  const agregarServicio = svc => {
    const iva = svc.APLICA_IVA ? ivaGlobal : 0;
    setDetalles(d=>[...d,{
      DESCRIPCION: svc.SERVICIO, CANTIDAD:1,
      VALOR: Number(svc.VALOR)||0, DESCUENTO:0,
      PORCENTAJE_IVA: iva,
      COD_CONSUMO: svc.COD,
    }]);
  };

  // Calculos
  const subtotal0  = detalles.reduce((s,d)=>(Number(d.VALOR)||0)*(Number(d.CANTIDAD)||1)-(Number(d.DESCUENTO)||0),0);
  const totalIva   = detalles.reduce((s,d)=>{
    const base=(Number(d.VALOR)||0)*(Number(d.CANTIDAD)||1)-(Number(d.DESCUENTO)||0);
    return s+base*(Number(d.PORCENTAJE_IVA)||0)/100;
  },0);
  const totalDesc  = detalles.reduce((s,d)=>s+(Number(d.DESCUENTO)||0),0);
  const total      = subtotal0+totalIva;
  const totalPagos = pagos.reduce((s,p)=>s+Number(p.VALOR||0),0);

  const guardar = async () => {
    if (!form.COD_PACIENTE) { setErr('Seleccione un paciente'); return; }
    if (!form.RAZON_SOCIAL) { setErr('Razon social es obligatoria'); return; }
    if (detalles.length===0){ setErr('Agregue al menos un producto'); return; }
    if (pagos.length===0)   { setErr('Agregue al menos una forma de pago'); return; }
    if (Math.abs(totalPagos-total)>0.01){ setErr(`Total pagos ($${totalPagos.toFixed(2)}) no coincide con total ($${total.toFixed(2)})`); return; }
    setSaving(true); setErr('');
    try {
      const { data } = await api.post('/facturacion', {
        ...form, detalles, pagos,
        COD_TURNO: turno?.COD,
        consumos_ids: consumosIds,
      });
      const sri = data?.sri;
      if (sri?.estado === 'AUTORIZADO') {
        setSriInfo({ ok: true, msg: '✅ Autorizada por el SRI — N° ' + sri.numero_autorizacion });
        setTimeout(() => onGuardar(), 2500);
      } else if (sri?.errores?.length) {
        setSriInfo({ ok: false, msg: '⚠️ Factura guardada pero el SRI devolvió: ' + sri.errores.join(' | ') });
        setTimeout(() => onGuardar(), 4000);
      } else if (sri?.detalle) {
        setSriInfo({ ok: false, msg: '⚠️ SRI pendiente: ' + sri.detalle });
        setTimeout(() => onGuardar(), 3000);
      } else {
        onGuardar();
      }
    } catch(e){ setErr(e.response?.data?.error||e.message); }
    finally { setSaving(false); }
  };

  return (
    <div className="mb" onClick={e=>e.target===e.currentTarget&&onCerrar()}>
      <div className="mx">
        <div className="mh" style={{background:'var(--navy)',color:'#fff'}}>
          <span style={{fontWeight:700,fontSize:13}}>Registrar documento</span>
          <span style={{cursor:'pointer',fontSize:18,opacity:.8}} onClick={onCerrar}>&#x2715;</span>
        </div>
        <div className="mbd">
          {/* Cabecera */}
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:10,marginBottom:12}}>
            <div>
              <label className="form-label" style={{fontSize:10}}>Fecha</label>
              <div style={{fontSize:12,padding:'5px 0'}}>{new Date().toLocaleDateString('es-EC')}</div>
            </div>
            <div>
              <label className="form-label" style={{fontSize:10}}>Caja</label>
              <select className="form-control" style={{fontSize:12}} value={form.COD_CAJA} onChange={e=>set('COD_CAJA',e.target.value)}>
                {cajas.map(c=><option key={c.COD} value={c.COD}>{c.CAJA}</option>)}
              </select>
            </div>
            <div>
              <label className="form-label" style={{fontSize:10}}>Tipo identificacion</label>
              <select className="form-control" style={{fontSize:12}} value={form.C_TIPO_IDENTIFICACION} onChange={e=>set('C_TIPO_IDENTIFICACION',e.target.value)}>
                <option value="CDL">Cedula</option>
                <option value="RUC">RUC</option>
                <option value="PSP">Pasaporte</option>
                <option value="NAP">N/A</option>
              </select>
            </div>
          </div>

          {cajaAbierta===false&&(
            <div style={{background:'var(--red-lt)',color:'var(--red)',padding:'8px 10px',borderRadius:6,fontSize:12,marginBottom:12,fontWeight:600}}>
              ⚠️ Esta caja no tiene un turno abierto. Ábrela desde "🔒 Cierre de Caja" antes de facturar.
            </div>
          )}

          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
            <div>
              <label className="form-label" style={{fontSize:10}}>Razon social *</label>
              {turno
                ? <div style={{fontSize:12,fontWeight:600,padding:'5px 0'}}>{form.RAZON_SOCIAL}</div>
                : <div style={{position:'relative'}}>
                    {form.COD_PACIENTE
                      ? (modoFactura==='otro'
                          ? <input className="form-control" style={{fontSize:12}} placeholder="Nombre de quien factura..." value={form.RAZON_SOCIAL} onChange={e=>set('RAZON_SOCIAL',e.target.value)} />
                          : <div style={{display:'flex',alignItems:'center',gap:6,background:'var(--blue-lt)',borderRadius:5,padding:'5px 8px',fontSize:12}}>
                              <span style={{flex:1,fontWeight:600}}>{form.RAZON_SOCIAL}</span>
                              <span style={{cursor:'pointer'}} onClick={()=>{setForm(f=>({...f,COD_PACIENTE:'',RAZON_SOCIAL:'',IDENTIFICACION:''}));setModoFactura('propio');setPerfilesFacturacion([]);}}>&#x2715;</span>
                            </div>
                        )
                      : <>
                          <input className="form-control" style={{fontSize:12}} placeholder="Buscar paciente..." value={busqPac} onChange={e=>setBusqPac(e.target.value)} />
                          {sugsPac.length>0&&(
                            <div style={{position:'absolute',top:'100%',left:0,right:0,background:'#fff',border:'1px solid var(--border)',borderRadius:5,zIndex:10,maxHeight:160,overflowY:'auto',boxShadow:'0 4px 12px rgba(0,0,0,.1)'}}>
                              {sugsPac.map(p=>(
                                <div key={p.COD} onClick={()=>selPac(p)} style={{padding:'6px 10px',fontSize:12,cursor:'pointer',borderBottom:'1px solid var(--bg)'}}
                                  onMouseEnter={e=>e.currentTarget.style.background='var(--blue-lt)'}
                                  onMouseLeave={e=>e.currentTarget.style.background=''}>
                                  <strong>{p.NOMBRE_COMPLETO?.trim()}</strong> <span style={{color:'var(--text3)',marginLeft:6}}>{p.IDENTIFICACION}</span>
                                </div>
                              ))}
                            </div>
                          )}
                        </>
                    }
                  </div>
              }
              {(turno||form.COD_PACIENTE)&&(
                <select className="form-control" style={{fontSize:11,marginTop:5}} value={modoFactura} onChange={e=>cambiarModoFactura(e.target.value)}>
                  <option value="propio">Facturar al paciente</option>
                  {perfilesFacturacion.map(pf=>(
                    <option key={pf.COD} value={pf.COD}>{pf.APELLIDOS} {pf.NOMBRES} — {pf.IDENTIFICACION}</option>
                  ))}
                  <option value="otro">Otra persona/empresa (escribir)...</option>
                </select>
              )}
            </div>
            <div>
              <label className="form-label" style={{fontSize:10}}>Identificacion</label>
              <input className="form-control" style={{fontSize:12}} value={form.IDENTIFICACION} onChange={e=>set('IDENTIFICACION',e.target.value)} />
            </div>
            <div>
              <label className="form-label" style={{fontSize:10}}>Telefono</label>
              <input className="form-control" style={{fontSize:12}} value={form.TELEFONO||''} onChange={e=>set('TELEFONO',e.target.value)} />
            </div>
            <div>
              <label className="form-label" style={{fontSize:10}}>Observacion</label>
              <input className="form-control" style={{fontSize:12}} value={form.OBSERVACION||''} onChange={e=>set('OBSERVACION',e.target.value)} />
            </div>
          </div>

          {/* Pendientes de facturar */}
          {pendientes.length>0&&(
            <div style={{border:'1px solid var(--amber)',background:'var(--amber-lt)',borderRadius:8,padding:12,marginBottom:12}}>
              <div style={{fontSize:12,fontWeight:600,color:'var(--amber)',marginBottom:8}}>
                📋 Exámenes pendientes de facturar ({pendientes.length})
              </div>
              {pendientes.map(p=>{
                const yaAgregado = consumosIds.includes(p.COD);
                return (
                  <div key={p.COD} style={{display:'flex',alignItems:'center',gap:8,padding:'4px 0'}}>
                    <label style={{display:'flex',alignItems:'center',gap:8,flex:1,fontSize:12,cursor:yaAgregado?'default':'pointer',opacity:yaAgregado?0.5:1}}>
                      <input type="checkbox" disabled={yaAgregado} checked={pendSel.includes(p.COD)} onChange={()=>togglePend(p.COD)} style={{width:14,height:14,cursor:'pointer'}}/>
                      <span style={{flex:1}}>{p.DESCRIPCION}{yaAgregado&&' ✓ agregado'}</span>
                      <span style={{fontWeight:600}}>{fmt(p.VALOR)}</span>
                    </label>
                    {!yaAgregado && p.C_ESTADO==='PND' && (
                      <button type="button" title="El paciente no se hizo esto en este centro"
                        style={{fontSize:11,color:'var(--red, #b03030)',background:'none',border:'none',cursor:'pointer',padding:'2px 6px'}}
                        onClick={()=>anularPendiente(p.COD)}>
                        Anular
                      </button>
                    )}
                  </div>
                );
              })}
              <button className="btn btn-sm" style={{marginTop:8,background:'var(--navy)',color:'#fff',border:'none'}}
                onClick={agregarPendientesSel}>
                + Agregar seleccionados a la factura
              </button>
            </div>
          )}

          {/* Tabs */}
          <div className="tab-btns">
            <button className={`tab-btn ${tab==='productos'?'on':''}`} onClick={()=>setTab('productos')}>Productos</button>
            <button className={`tab-btn ${tab==='pago'?'on':''}`} onClick={()=>setTab('pago')}>Forma de pago</button>
            <button className={`tab-btn ${tab==='historial'?'on':''}`} onClick={verHistorial}>Historial</button>
          </div>

          {/* Tab Productos */}
          {tab==='productos'&&(
            <div style={{paddingTop:10}}>
              <div style={{display:'flex',justifyContent:'flex-end',marginBottom:6}}>
                <select className="form-control" style={{width:220,fontSize:12}}
                  onChange={e=>{if(e.target.value){agregarServicio(servicios.find(s=>s.COD==e.target.value));e.target.value='';}}}>
                  <option value="">+ Agregar servicio</option>
                  {servicios.map(s=><option key={s.COD} value={s.COD}>{s.SERVICIO} — {fmt(s.VALOR)}</option>)}
                </select>
              </div>
              <table className="fac-tbl">
                <thead><tr><th>Producto</th><th>Precio</th><th>Cant.</th><th>Des.%</th><th>Des.$</th><th>Total</th><th style={{width:24}}></th></tr></thead>
                <tbody>
                  {detalles.length===0&&<tr><td colSpan={7} style={{textAlign:'center',color:'var(--text3)',padding:'10px 0'}}>Sin productos</td></tr>}
                  {detalles.map((d,i)=>{
                    const tot=(Number(d.VALOR)||0)*(Number(d.CANTIDAD)||1)-(Number(d.DESCUENTO)||0);
                    return (
                      <tr key={i}>
                        <td><input style={{...{},width:'100%',border:'none',background:'transparent',fontSize:11}} value={d.DESCRIPCION} onChange={e=>setD(i,'DESCRIPCION',e.target.value)} /></td>
                        <td><input type="number" style={{width:55,...inp}} min={0} step=".01" value={d.VALOR} onChange={e=>setD(i,'VALOR',Number(e.target.value))} /></td>
                        <td><input type="number" style={{width:40,...inp}} min={1} value={d.CANTIDAD} onChange={e=>setD(i,'CANTIDAD',Number(e.target.value))} /></td>
                        <td><input type="number" style={{width:40,...inp,background:'var(--surface)',cursor:'default'}} min={0} max={100} value={d.PORCENTAJE_IVA} readOnly /></td>
                        <td><input type="number" style={{width:50,...inp}} min={0} step=".01" value={d.DESCUENTO} onChange={e=>setD(i,'DESCUENTO',Number(e.target.value))} /></td>
                        <td style={{fontWeight:600,fontSize:12}}>{fmt(tot)}</td>
                        <td><button onClick={()=>{
                          const fila=detalles[i];
                          setDetalles(d=>d.filter((_,j)=>j!==i));
                          if(fila._consumoId){
                            setConsumosIds(ids=>ids.filter(x=>x!==fila._consumoId));
                            setPendSel(s=>s.filter(x=>x!==fila._consumoId));
                          }
                        }} style={{background:'var(--red)',color:'#fff',border:'none',borderRadius:3,padding:'2px 5px',cursor:'pointer',fontSize:10}}>&#x2715;</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Totales */}
              <div style={{background:'var(--bg)',borderRadius:7,padding:'8px 12px'}}>
                {[['Subtotal 0%',fmt(subtotal0)],['Descuento',fmt(totalDesc)],['IVA',fmt(totalIva)],['TOTAL',fmt(total)]].map(([l,v])=>(
                  <div key={l} style={{display:'flex',justifyContent:'space-between',fontSize:l==='TOTAL'?13:11,fontWeight:l==='TOTAL'?700:400,color:l==='TOTAL'?'var(--navy)':'var(--text2)',marginBottom:2}}>
                    <span>{l}</span><span>{v}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tab Forma de pago */}
          {tab==='pago'&&(
            <div style={{paddingTop:10}}>
              <table className="fac-tbl">
                <thead><tr>
                  <th style={{width:30}}></th>
                  <th>Forma de pago</th>
                  <th>Valor a cobrar</th>
                  <th>Referencia / Adicional</th>
                </tr></thead>
                <tbody>
                  {pagos.length===0&&<tr><td colSpan={4} style={{textAlign:'center',color:'var(--text3)',padding:'10px 0'}}>Sin formas de pago</td></tr>}
                  {pagos.map((p,i)=>(
                    <tr key={i}>
                      <td><button onClick={()=>setPagos(p=>p.filter((_,j)=>j!==i))} style={{background:'var(--red)',color:'#fff',border:'none',borderRadius:3,padding:'2px 5px',cursor:'pointer',fontSize:10}}>&#x2715;</button></td>
                      <td>
                        <select style={{...inp,width:180}} value={p.COD_FORMA_DE_PAGO} onChange={e=>setP(i,'COD_FORMA_DE_PAGO',e.target.value)}>
                          {formasPago.map(f=><option key={f.COD} value={f.COD}>{f.FORMA_DE_PAGO}</option>)}
                        </select>
                      </td>
                      <td><input type="number" style={{...inp,width:80}} min={0} step=".01" value={p.VALOR} onChange={e=>setP(i,'VALOR',Number(e.target.value))} /></td>
                      <td><input style={{...inp,width:150}} value={p.ADICIONAL||''} onChange={e=>setP(i,'ADICIONAL',e.target.value)} placeholder="Referencia..." /></td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-sm" style={{background:'var(--navy)',color:'#fff',border:'none',marginBottom:10}}
                onClick={()=>setPagos(p=>[...p,{COD_FORMA_DE_PAGO:formasPago[0]?.COD||1,VALOR:total-totalPagos>0?Number((total-totalPagos).toFixed(2)):0,ADICIONAL:''}])}>
                + Agregar forma de pago
              </button>
              {/* Resumen */}
              <div style={{background:'var(--bg)',borderRadius:7,padding:'8px 12px'}}>
                {[['Subtotal 0%',fmt(subtotal0)],['Descuento',fmt(totalDesc)],['IVA',fmt(totalIva)],['Total',fmt(total)],['Total pagos',fmt(totalPagos)]].map(([l,v])=>(
                  <div key={l} style={{display:'flex',justifyContent:'space-between',fontSize:l==='Total'?13:11,fontWeight:l==='Total'?700:400,color:l==='Total'?'var(--navy)':'var(--text2)',marginBottom:2}}>
                    <span>{l}</span><span style={{color:l==='Total pagos'&&Math.abs(totalPagos-total)>0.01?'var(--red)':undefined}}>{v}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tab Historial */}
          {tab==='historial'&&(
            <div style={{paddingTop:10}}>
              {histErr&&<div style={{background:'var(--red-lt)',color:'var(--red)',padding:8,borderRadius:6,fontSize:12,marginBottom:10}}>{histErr}</div>}
              {loadingHist&&<div style={{textAlign:'center',padding:16,color:'var(--text3)',fontSize:12}}>Cargando historial...</div>}
              {!loadingHist&&historial&&historial.length===0&&(
                <div style={{textAlign:'center',padding:16,color:'var(--text3)',fontSize:12}}>Sin facturas previas para este paciente</div>
              )}
              {!loadingHist&&historial&&historial.length>0&&(
                <table className="fac-tbl">
                  <thead><tr>
                    <th>Fecha</th><th>N° Factura</th><th>Estado</th><th style={{textAlign:'right'}}>Total</th>
                  </tr></thead>
                  <tbody>
                    {historial.map(h=>{
                      const est=ESTADOS[h.C_ESTADO]||ESTADOS.ACT;
                      return (
                        <tr key={h.COD}>
                          <td style={{fontSize:11}}>{h.FECHA?new Date(h.FECHA).toLocaleDateString('es-EC'):'—'}</td>
                          <td style={{fontSize:11}}>
                            {h.SECUENCIAL_SRI
                              ? `${h.ESTAB||'001'}-001-${String(h.SECUENCIAL_SRI).padStart(9,'0')}`
                              : `#${h.COD}`}
                          </td>
                          <td><span style={{background:est.bg,color:est.fg,padding:'1px 6px',borderRadius:3,fontSize:9,fontWeight:600}}>{est.label}</span></td>
                          <td style={{textAlign:'right',fontWeight:600,fontSize:12}}>{fmt(h.TOTAL)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          )}

          {err&&<div style={{color:'var(--red)',fontSize:12,marginTop:8,padding:'5px 8px',background:'#fff5f5',borderRadius:4}}>{err}</div>}
          {sriInfo&&(
            <div style={{fontSize:12,marginTop:8,padding:'7px 10px',borderRadius:4,
              background: sriInfo.ok ? '#f0fdf4' : '#fffbeb',
              color:      sriInfo.ok ? '#15803d' : '#92400e',
              border:     `1px solid ${sriInfo.ok ? '#86efac' : '#fcd34d'}`}}>
              {sriInfo.msg}
            </div>
          )}
        </div>
        <div className="mf">
          <button className="btn btn-sm" onClick={onCerrar}>Cancelar</button>
          <button className="btn btn-primary btn-sm" disabled={saving||cajaAbierta===false} onClick={guardar}>
            {saving ? '⏳ Guardando y enviando al SRI...' : 'Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

const inp = {padding:'3px 5px',fontSize:11,border:'1px solid var(--border)',borderRadius:3};

/* ── Detalle Factura ─────────────────────────────────── */
const SRI_ESTADOS = {
  F:{ label:'Pendiente SRI', bg:'#F59E0B', fg:'#fff' },
  A:{ label:'Autorizado',    bg:'#10B981', fg:'#fff' },
  D:{ label:'Devuelta',      bg:'#EF4444', fg:'#fff' },
  E:{ label:'Error SRI',     bg:'#6B7280', fg:'#fff' },
};

function DetalleFactura({ fac, onAnular, onNueva, onRefresh }) {
  const [sriLoading, setSriLoading] = useState(false);
  const [sriMsg,     setSriMsg]     = useState('');

  if (!fac) return (
    <div className="fac-panel">
      <div className="fac-hdr">Detalle</div>
      <div style={{flex:1,display:'flex',alignItems:'center',justifyContent:'center',color:'var(--text3)',fontSize:13}}>
        Seleccione una factura
      </div>
      <div style={{padding:'10px 14px',borderTop:'1px solid var(--border)'}}>
        <button className="btn btn-primary btn-sm" style={{width:'100%'}} onClick={onNueva}>+ Nueva factura</button>
      </div>
    </div>
  );

  const est    = ESTADOS[fac.C_ESTADO]||ESTADOS.ACT;
  const sriEst = SRI_ESTADOS[fac.C_ESTADO_SRI] || SRI_ESTADOS.F;
  const subtotal = (fac.detalles||[]).filter(d=>d.C_ESTADO==='ACT').reduce((s,d)=>(Number(d.VALOR)||0)*(Number(d.CANTIDAD)||1)-(Number(d.DESCUENTO)||0)+s,0);
  const iva      = (fac.detalles||[]).filter(d=>d.C_ESTADO==='ACT').reduce((s,d)=>s+Number(d.IVA||0),0);
  const total    = subtotal+iva;

  const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
  const token = localStorage.getItem('token');

  const enviarSRI = async () => {
    if (!window.confirm('Enviar esta factura al SRI?')) return;
    setSriLoading(true); setSriMsg('');
    try {
      const { data } = await api.post(`/facturacion/${fac.COD}/enviar-sri`);
      if (data.estado === 'AUTORIZADO') {
        setSriMsg('✅ Factura AUTORIZADA — N° ' + data.numero_autorizacion);
      } else if (data.errores?.length) {
        setSriMsg('❌ ' + data.errores.join(' | '));
      } else if (data.mensajes?.length) {
        setSriMsg('⚠️ ' + data.mensajes.join(' | '));
      } else {
        setSriMsg('Estado: ' + data.estado + (data.detalle ? ' — ' + data.detalle : ''));
      }
      if (onRefresh) onRefresh(fac.COD);
    } catch(e) {
      setSriMsg('❌ ' + (e.response?.data?.error || e.message));
    }
    setSriLoading(false);
  };

  const descargarRIDE = () => {
    const url = `${API}/facturacion/${fac.COD}/ride`;
    fetch(url, { headers:{ Authorization:`Bearer ${token}` }})
      .then(r => r.blob())
      .then(blob => {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = `RIDE_${fac.IDENTIFICACION}_${fac.COD}.pdf`;
        a.click();
      });
  };

  const consultarSRI = async () => {
    setSriLoading(true); setSriMsg('');
    try {
      const { data } = await api.post(`/facturacion/${fac.COD}/consultar-sri`);
      if (data.estado === 'AUTORIZADO') {
        setSriMsg('✅ Autorizada — N° ' + data.numero_autorizacion);
      } else {
        setSriMsg('Estado SRI: ' + data.estado + (data.mensajes?.length ? ' — ' + data.mensajes.join(' | ') : ''));
      }
      if (onRefresh) onRefresh(fac.COD);
    } catch(e) {
      setSriMsg('❌ ' + (e.response?.data?.error || e.message));
    }
    setSriLoading(false);
  };

  const generarNotaCredito = async () => {
    const motivo = window.prompt('Motivo de la nota de crédito (obligatorio):', '');
    if (!motivo?.trim()) return;
    if (!window.confirm(`Se emitirá una NOTA DE CRÉDITO real ante el SRI por el total de esta factura ($${fac.TOTAL||''}), y la factura quedará anulada automáticamente si se autoriza.\n\nMotivo: "${motivo.trim()}"\n\n¿Continuar?`)) return;
    setSriLoading(true); setSriMsg('');
    try {
      const { data } = await api.post(`/facturacion/${fac.COD}/nota-credito`, { motivo: motivo.trim() });
      if (data.estado === 'AUTORIZADO') {
        setSriMsg('✅ Nota de crédito AUTORIZADA — N° ' + data.numero_autorizacion);
      } else if (data.errores?.length) {
        setSriMsg('❌ ' + data.errores.join(' | '));
      } else if (data.mensajes?.length) {
        setSriMsg('⚠️ ' + data.mensajes.join(' | '));
      } else {
        setSriMsg('Estado: ' + data.estado + (data.detalle ? ' — ' + data.detalle : ''));
      }
      if (onRefresh) onRefresh(fac.COD);
    } catch(e) {
      setSriMsg('❌ ' + (e.response?.data?.error || e.message));
    }
    setSriLoading(false);
  };

  const descargarXML = () => {
    const url = `${API}/facturacion/${fac.COD}/xml`;
    fetch(url, { headers:{ Authorization:`Bearer ${token}` }})
      .then(r => r.text())
      .then(xml => {
        const a = document.createElement('a');
        a.href = 'data:application/xml,' + encodeURIComponent(xml);
        a.download = `${fac.IDENTIFICACION}_${fac.COD}.xml`;
        a.click();
      });
  };

  return (
    <div className="fac-panel">
      <div className="fac-hdr">
        <span>Factura #{fac.COD}</span>
        <div style={{display:'flex',gap:5,alignItems:'center'}}>
          <span style={{background:est.bg,color:est.fg,padding:'2px 7px',borderRadius:3,fontSize:10,fontWeight:600}}>{est.label}</span>
          <span style={{background:sriEst.bg,color:sriEst.fg,padding:'2px 7px',borderRadius:3,fontSize:10,fontWeight:600}}>{sriEst.label}</span>
        </div>
      </div>
      <div className="fac-det-body">
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:12}}>
          {[['Paciente',fac.PACIENTE_NOMBRE||fac.RAZON_SOCIAL],['Identificacion',fac.IDENTIFICACION],
            ['Fecha',fac.FECHA_FMT||fac.FECHA],['Caja',fac.CAJA],
            ['Telefono',fac.TELEFONO],['Observacion',fac.OBSERVACION]].map(([l,v])=>(
            v&&<div key={l}>
              <div style={{fontSize:9,color:'var(--text3)',textTransform:'uppercase',fontWeight:700}}>{l}</div>
              <div style={{fontSize:11}}>{v}</div>
            </div>
          ))}
        </div>

        {/* Datos SRI si está autorizada */}
        {fac.C_ESTADO_SRI==='A'&&(
          <div style={{background:'#f0fdf4',border:'1px solid #86efac',borderRadius:6,padding:'8px 10px',marginBottom:10,fontSize:11}}>
            <div style={{fontWeight:700,color:'#15803d',marginBottom:4}}>✅ Autorizada por el SRI</div>
            <div style={{color:'#166534'}}><strong>N° Aut:</strong> {fac.AUTORIZACION_SRI}</div>
            <div style={{color:'#166534'}}><strong>Clave:</strong> <span style={{fontSize:9,wordBreak:'break-all'}}>{fac.CLAVE_ACCESO_SRI}</span></div>
          </div>
        )}

        {/* Mensaje de operación SRI */}
        {sriMsg&&(
          <div style={{background: sriMsg.startsWith('✅')?'#f0fdf4':'#fef2f2',
                       border:`1px solid ${sriMsg.startsWith('✅')?'#86efac':'#fca5a5'}`,
                       borderRadius:5,padding:'7px 10px',marginBottom:8,fontSize:11,
                       color: sriMsg.startsWith('✅')?'#15803d':'#dc2626'}}>
            {sriMsg}
          </div>
        )}

        <table className="fac-tbl">
          <thead><tr><th>Producto</th><th>Cant.</th><th>Precio</th><th>Total</th></tr></thead>
          <tbody>
            {(fac.detalles||[]).filter(d=>d.C_ESTADO==='ACT').map((d,i)=>(
              <tr key={i}>
                <td>{d.DESCRIPCION}</td>
                <td style={{textAlign:'center'}}>{d.CANTIDAD}</td>
                <td>{fmt(d.VALOR)}</td>
                <td style={{fontWeight:600}}>{fmt((Number(d.VALOR)||0)*(Number(d.CANTIDAD)||1)-(Number(d.DESCUENTO)||0))}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="fac-total">
          <span>Subtotal</span><span style={{textAlign:'right'}}>{fmt(subtotal)}</span>
          <span>IVA</span><span style={{textAlign:'right'}}>{fmt(iva)}</span>
          <span style={{fontWeight:700,fontSize:14}}>TOTAL</span><span style={{textAlign:'right',fontWeight:700,fontSize:14}}>{fmt(total)}</span>
        </div>

        {(fac.pagos||[]).length>0&&(
          <div style={{marginTop:10}}>
            <div style={{fontSize:10,color:'var(--text3)',fontWeight:700,marginBottom:4}}>PAGOS</div>
            {(fac.pagos||[]).map((p,i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',fontSize:11,marginBottom:2}}>
                <span>{p.FORMA_DE_PAGO}</span><span style={{fontWeight:600}}>{fmt(p.VALOR)}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Botones SRI */}
      <div style={{padding:'8px 14px',borderTop:'1px solid var(--border)',background:'#f8fafc'}}>
        <div style={{fontSize:9,color:'var(--text3)',fontWeight:700,marginBottom:5}}>FACTURACIÓN ELECTRÓNICA SRI</div>
        <div style={{display:'flex',gap:5,flexWrap:'wrap'}}>
          {fac.C_ESTADO==='ACT'&&fac.C_ESTADO_SRI!=='A'&&(
            <button className="btn btn-sm" disabled={sriLoading}
              style={{background:'#2563eb',color:'#fff',border:'none',fontSize:11}}
              onClick={enviarSRI}>
              {sriLoading?'Enviando...':' Enviar al SRI'}
            </button>
          )}
          {fac.CLAVE_ACCESO_SRI&&fac.C_ESTADO_SRI!=='A'&&(
            <button className="btn btn-sm" disabled={sriLoading}
              style={{background:'#0891b2',color:'#fff',border:'none',fontSize:11}}
              onClick={consultarSRI}>
              {sriLoading?'Consultando...':' Consultar SRI'}
            </button>
          )}
          <button className="btn btn-sm"
            style={{background:'#059669',color:'#fff',border:'none',fontSize:11}}
            onClick={descargarRIDE}>
            ⬇ RIDE PDF
          </button>
          {fac.C_ESTADO_SRI==='A'&&(
            <button className="btn btn-sm"
              style={{background:'#7c3aed',color:'#fff',border:'none',fontSize:11}}
              onClick={descargarXML}>
              ⬇ XML
            </button>
          )}
          {fac.C_ESTADO_SRI==='A'&&fac.C_ESTADO==='ACT'&&(
            <button className="btn btn-sm" disabled={sriLoading}
              style={{background:'#b91c1c',color:'#fff',border:'none',fontSize:11}}
              onClick={generarNotaCredito}>
              {sriLoading?'Procesando...':'🧾 Nota de Crédito'}
            </button>
          )}
        </div>
      </div>

      <div style={{padding:'8px 14px',borderTop:'1px solid var(--border)',display:'flex',gap:6}}>
        {fac.C_ESTADO==='ACT'&&(
          <button className="btn btn-sm" style={{background:'var(--red)',color:'#fff',border:'none'}} onClick={onAnular}>Anular</button>
        )}
        <button className="btn btn-sm btn-primary" style={{marginLeft:'auto'}} onClick={onNueva}>+ Nueva</button>
      </div>
    </div>
  );
}

/* ── Pagina Principal ────────────────────────────────── */
const DENOMINACIONES = [100, 50, 20, 10, 5, 1, 0.50, 0.25, 0.10, 0.05, 0.01];

function ModalCierreCaja({ cajas, onCerrar }) {
  const [codCaja, setCodCaja]   = useState(cajas[0]?.COD || '');
  const [estado, setEstado]     = useState(null);
  const [loading, setLoading]   = useState(false);
  const [fondoInicial, setFondoInicial] = useState('');
  const [egDesc, setEgDesc]     = useState('');
  const [egValor, setEgValor]   = useState('');
  const [denoms, setDenoms]     = useState(()=>DENOMINACIONES.reduce((o,d)=>({...o,[d]:0}),{}));
  const [cajero, setCajero]         = useState('');
  const [supervisor, setSupervisor] = useState('');
  const [observaciones, setObservaciones] = useState('');
  const [resultado, setResultado]   = useState(null);
  const [err, setErr]               = useState('');

  const cargarEstado = useCallback(async (cod) => {
    if (!cod) return;
    setLoading(true); setErr('');
    try {
      const { data } = await api.get(`/facturacion/cierre-caja/estado?cod_caja=${cod}`);
      setEstado(data);
    } catch(e) { setErr(e.response?.data?.error || e.message); }
    setLoading(false);
  }, []);

  useEffect(() => { cargarEstado(codCaja); }, [codCaja, cargarEstado]);

  const abrir = async () => {
    setLoading(true); setErr('');
    try {
      await api.post('/facturacion/cierre-caja/abrir', { cod_caja: codCaja, fondo_inicial: Number(fondoInicial)||0 });
      setFondoInicial('');
      cargarEstado(codCaja);
    } catch(e) { setErr(e.response?.data?.error || e.message); }
    setLoading(false);
  };

  const agregarEgreso = async () => {
    if (!egDesc || !egValor) return;
    setErr('');
    try {
      await api.post('/facturacion/cierre-caja/egreso', {
        cod_turno_caja: estado.turno.COD, descripcion: egDesc, valor: Number(egValor)
      });
      setEgDesc(''); setEgValor('');
      cargarEstado(codCaja);
    } catch(e) { setErr(e.response?.data?.error || e.message); }
  };

  const totalVentas          = (estado?.ventas||[]).reduce((s,v)=>s+Number(v.TOTAL),0);
  const totalEfectivoVentas  = (estado?.ventas||[]).filter(v=>v.EFECTIVO==='V').reduce((s,v)=>s+Number(v.TOTAL),0);
  const totalEgresos         = (estado?.egresos||[]).reduce((s,e)=>s+Number(e.VALOR),0);
  const fondoInicialActual   = Number(estado?.turno?.FONDO_INICIAL || 0);
  const efectivoEsperado     = fondoInicialActual + totalEfectivoVentas - totalEgresos;
  const totalContado         = DENOMINACIONES.reduce((s,d)=>s + d*(Number(denoms[d])||0), 0);
  const diferencia           = totalContado - efectivoEsperado;
  const cuadra                = Math.abs(diferencia) < 0.01;

  const cerrar = async () => {
    setLoading(true); setErr('');
    try {
      const { data } = await api.post('/facturacion/cierre-caja/cerrar', {
        cod_turno_caja: estado.turno.COD,
        denominaciones: DENOMINACIONES.map(d=>({denominacion:d, cantidad:Number(denoms[d])||0})),
        cajero, supervisor, observaciones,
      });
      setResultado(data);
    } catch(e) { setErr(e.response?.data?.error || e.message); }
    setLoading(false);
  };

  return (
    <div className="mb" onClick={e=>e.target===e.currentTarget&&onCerrar()}>
      <div className="mx" style={{maxWidth:560}}>
        <div className="mh" style={{background:'var(--navy)',color:'#fff'}}>
          <span style={{fontWeight:700,fontSize:13}}>🔒 Cierre de Caja</span>
          {!resultado&&(
            <select value={codCaja} disabled={estado?.abierto} onChange={e=>setCodCaja(e.target.value)}
              style={{fontSize:11,marginLeft:'auto',marginRight:10}}>
              {cajas.map(c=><option key={c.COD} value={c.COD}>{c.CAJA}</option>)}
            </select>
          )}
          <span style={{cursor:'pointer',fontSize:18,opacity:.8}} onClick={onCerrar}>&#x2715;</span>
        </div>
        <div className="mbd">
          {err&&<div style={{background:'var(--red-lt)',color:'var(--red)',padding:8,borderRadius:6,fontSize:12,marginBottom:10}}>{err}</div>}

          {resultado ? (
            <div style={{textAlign:'center',padding:20}}>
              <div style={{fontSize:32,marginBottom:8}}>✅</div>
              <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>Caja cerrada correctamente</div>
              <div style={{fontSize:12,color:'var(--text3)',marginBottom:16}}>
                Diferencia: <strong style={{color:Math.abs(resultado.diferencia)<0.01?'var(--green)':'var(--red)'}}>
                  {fmt(resultado.diferencia)}
                </strong>
              </div>
              <div style={{display:'flex',gap:8,justifyContent:'center'}}>
                <button className="btn btn-primary" onClick={async()=>{
                  try{
                    const token=localStorage.getItem('token');
                    const res=await fetch(`${process.env.REACT_APP_API_URL||'http://localhost:3001/api'}/facturacion/cierre-caja/${resultado.cod}/pdf`,
                      {headers:{Authorization:`Bearer ${token}`}});
                    if(!res.ok){alert('Error al generar el PDF');return;}
                    const blob=await res.blob();
                    const a=document.createElement('a');
                    a.href=URL.createObjectURL(blob);
                    a.download=`Cierre_Caja_${resultado.cod}.pdf`;
                    a.click();
                  }catch(e){alert('Error: '+e.message);}
                }}>📄 Descargar PDF</button>
                <button className="btn btn-sm" onClick={onCerrar}>Cerrar</button>
              </div>
            </div>
          ) : loading&&!estado ? (
            <div style={{textAlign:'center',padding:24,color:'var(--text3)'}}>Cargando...</div>
          ) : !estado?.abierto ? (
            <div>
              <div style={{fontSize:12,color:'var(--text3)',marginBottom:12}}>
                Esta caja no tiene un turno abierto. Registra el fondo inicial para abrirla.
              </div>
              <label className="form-label" style={{fontSize:11}}>Fondo inicial</label>
              <input type="number" step="0.01" className="form-control" value={fondoInicial}
                onChange={e=>setFondoInicial(e.target.value)} placeholder="0.00" style={{marginBottom:12}}/>
              <button className="btn btn-primary" disabled={loading} onClick={abrir}>
                {loading?'Abriendo...':'Abrir caja'}
              </button>
            </div>
          ) : (
            <>
              <div style={{fontSize:11,color:'var(--text3)',marginBottom:12}}>
                Turno abierto: {new Date(estado.turno.FECHA_APERTURA).toLocaleString('es-EC')}
              </div>

              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:14}}>
                <div style={{background:'var(--surface)',borderRadius:8,padding:'8px 10px'}}>
                  <div style={{fontSize:10,color:'var(--text3)'}}>Fondo inicial</div>
                  <div style={{fontSize:15,fontWeight:700}}>{fmt(fondoInicialActual)}</div>
                </div>
                <div style={{background:'var(--surface)',borderRadius:8,padding:'8px 10px'}}>
                  <div style={{fontSize:10,color:'var(--text3)'}}>Ventas del turno</div>
                  <div style={{fontSize:15,fontWeight:700}}>{fmt(totalVentas)}</div>
                </div>
              </div>

              <div style={{fontSize:11,fontWeight:700,color:'var(--text2)',marginBottom:6}}>VENTAS POR FORMA DE PAGO</div>
              {(estado.ventas||[]).length===0&&<div style={{fontSize:11,color:'var(--text3)',marginBottom:10}}>Sin ventas en este turno</div>}
              {(estado.ventas||[]).map(v=>(
                <div key={v.COD_FP||v.FORMA_DE_PAGO} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'3px 0'}}>
                  <span>{v.FORMA_DE_PAGO||'Sin especificar'}</span>
                  <span style={{fontWeight:600}}>{fmt(v.TOTAL)}</span>
                </div>
              ))}

              <div style={{fontSize:11,fontWeight:700,color:'var(--text2)',margin:'14px 0 6px'}}>EGRESOS DEL TURNO</div>
              {(estado.egresos||[]).map(e=>(
                <div key={e.COD} style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'3px 0'}}>
                  <span>{e.DESCRIPCION}</span>
                  <span style={{fontWeight:600,color:'var(--red)'}}>-{fmt(e.VALOR)}</span>
                </div>
              ))}
              <div style={{display:'flex',gap:6,marginTop:6,marginBottom:14}}>
                <input className="form-control" style={{fontSize:11,flex:2}} placeholder="Descripción del gasto"
                  value={egDesc} onChange={e=>setEgDesc(e.target.value)}/>
                <input type="number" step="0.01" className="form-control" style={{fontSize:11,flex:1}} placeholder="$0.00"
                  value={egValor} onChange={e=>setEgValor(e.target.value)}/>
                <button className="btn btn-sm" onClick={agregarEgreso}>+ Agregar</button>
              </div>

              <div style={{background:'var(--blue-lt)',borderRadius:8,padding:'8px 12px',display:'flex',justifyContent:'space-between',marginBottom:14}}>
                <span style={{fontSize:12,fontWeight:700,color:'var(--navy)'}}>Efectivo esperado en caja</span>
                <span style={{fontSize:15,fontWeight:700,color:'var(--navy)'}}>{fmt(efectivoEsperado)}</span>
              </div>

              <div style={{fontSize:11,fontWeight:700,color:'var(--text2)',marginBottom:6}}>CONTEO DE EFECTIVO POR DENOMINACIÓN</div>
              <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:6,marginBottom:10}}>
                {DENOMINACIONES.map(d=>(
                  <div key={d}>
                    <div style={{fontSize:10,color:'var(--text3)'}}>{fmt(d)}</div>
                    <input type="number" min="0" className="form-control" style={{fontSize:11,textAlign:'center'}}
                      value={denoms[d]} onChange={e=>setDenoms(s=>({...s,[d]:e.target.value}))}/>
                  </div>
                ))}
              </div>

              <div style={{display:'flex',justifyContent:'space-between',fontSize:12,padding:'6px 0',borderTop:'1px solid var(--border)'}}>
                <span style={{fontWeight:700}}>Total contado</span><span style={{fontWeight:700}}>{fmt(totalContado)}</span>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',fontSize:12,marginBottom:14}}>
                <span>Diferencia</span>
                <span style={{fontWeight:700,color:cuadra?'var(--green)':'var(--red)'}}>
                  {fmt(diferencia)} {cuadra?'':(diferencia>0?'(sobrante)':'(faltante)')}
                </span>
              </div>

              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:10}}>
                <div>
                  <label className="form-label" style={{fontSize:10}}>Cajero responsable</label>
                  <input className="form-control" style={{fontSize:12}} value={cajero} onChange={e=>setCajero(e.target.value)}/>
                </div>
                <div>
                  <label className="form-label" style={{fontSize:10}}>Supervisor</label>
                  <input className="form-control" style={{fontSize:12}} value={supervisor} onChange={e=>setSupervisor(e.target.value)}/>
                </div>
              </div>
              <div style={{marginBottom:14}}>
                <label className="form-label" style={{fontSize:10}}>Observaciones</label>
                <textarea className="form-control" rows={2} style={{fontSize:12}} value={observaciones} onChange={e=>setObservaciones(e.target.value)}/>
              </div>

              <div style={{display:'flex',justifyContent:'flex-end',gap:8}}>
                <button className="btn btn-sm" onClick={onCerrar}>Cancelar</button>
                <button className="btn btn-primary" disabled={loading} onClick={cerrar}>
                  {loading?'Cerrando...':'🔒 Confirmar cierre'}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default function Facturacion() {
  const [searchParams] = useSearchParams();
  const hoy = (()=>{const d=new Date();return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;})();

  const [filtros,    setFiltros]    = useState({fecha:hoy,estado:''});
  const [facturas,   setFacturas]   = useState([]);
  const [facSel,     setFacSel]     = useState(null);
  const [loading,    setLoading]    = useState(false);
  const [modal,      setModal]      = useState(false);
  const [modalCierre,setModalCierre]= useState(false);
  const [turnoUrl,   setTurnoUrl]   = useState(null); // paciente cargado desde URL
  const [cajas,      setCajas]      = useState([]);
  const [formasPago, setFormasPago] = useState([]);
  const [servicios,  setServicios]  = useState([]);
  const [ivaGlobal,  setIvaGlobal]  = useState(15);
  const [page,       setPage]       = useState(1);
  const [total,      setTotal]      = useState(0);

  const cargar = useCallback(async()=>{
    setLoading(true);
    try{
      const p = new URLSearchParams({fecha:filtros.fecha,estado:filtros.estado,page,limit:30}).toString();
      const{data}=await api.get(`/facturacion?${p}`);
      setFacturas(data.data); setTotal(data.total);
    }catch(e){console.error(e);}
    finally{setLoading(false);}
  },[filtros,page]);

  const cargarDet = async cod=>{
    try{const{data}=await api.get(`/facturacion/${cod}`);setFacSel(data);}catch{}
  };

  useEffect(()=>{cargar();},[cargar]);

  // Auto-abrir modal con paciente si viene de ?paciente=COD
  useEffect(()=>{
    const codPac   = searchParams.get('paciente');
    const codTurno = searchParams.get('turno');
    if (!codPac) return;

    if (codTurno) {
      // Cargar datos completos del turno (incluye servicio + precio)
      api.get(`/facturacion/turno/${codTurno}`).then(r => {
        const t = r.data;
        if (!t?.COD_PACIENTE) return;
        setTurnoUrl(t);
        setModal(true);
      }).catch(()=>{
        // Fallback: solo datos del paciente
        api.get(`/pacientes/${codPac}`).then(r => {
          const p = r.data;
          if (p?.COD) { setTurnoUrl({ COD_PACIENTE:p.COD, IDENTIFICACION:p.IDENTIFICACION,
            APELLIDO_PATERNO:p.APELLIDO_PATERNO||'', APELLIDO_MATERNO:p.APELLIDO_MATERNO||'',
            PRIMER_NOMBRE:p.PRIMER_NOMBRE||'', TELEFONO:p.TELEFONO||'',
            EMAIL:p.EMAIL||'', DIRECCION:p.DIRECCION||'' }); setModal(true); }
        }).catch(()=>{});
      });
    } else {
      api.get(`/pacientes/${codPac}`).then(r => {
        const p = r.data;
        if (!p?.COD) return;
        setTurnoUrl({ COD_PACIENTE:p.COD, C_TIPO_IDENTIFICACION:p.C_TIPO_IDENTIFICACION||'CDL',
          IDENTIFICACION:p.IDENTIFICACION, APELLIDO_PATERNO:p.APELLIDO_PATERNO||'',
          APELLIDO_MATERNO:p.APELLIDO_MATERNO||'', PRIMER_NOMBRE:p.PRIMER_NOMBRE||'',
          TELEFONO:p.TELEFONO||'', EMAIL:p.EMAIL||'', DIRECCION:p.DIRECCION||'' });
        setModal(true);
      }).catch(()=>{});
    }
  }, [searchParams]);
  useEffect(()=>{
    api.get('/facturacion/catalogos/cajas').then(r=>setCajas(r.data)).catch(()=>{});
    api.get('/facturacion/catalogos/formas-pago').then(r=>setFormasPago(r.data)).catch(()=>{});
    api.get('/catalogos/servicios').then(r=>setServicios(r.data)).catch(()=>{});
    api.get('/configuracion/iva').then(r=>setIvaGlobal(r.data?.iva||15)).catch(()=>{});
  },[]);

  const anular = async()=>{
    const msg = facSel?.C_ESTADO_SRI === 'A'
      ? 'Esta factura YA FUE AUTORIZADA por el SRI — es un documento fiscal válido.\n\nAnularla aquí solo la marca como anulada en este sistema, NO la reversa ante el SRI. Para eso corresponde emitir una NOTA DE CRÉDITO por separado (este sistema todavía no la genera automáticamente).\n\n¿Continuar de todas formas?'
      : '¿Anular esta factura? Como no fue autorizada por el SRI, no es un documento fiscal válido — se puede anular sin necesidad de nota de crédito.';
    if(!window.confirm(msg))return;
    await api.patch(`/facturacion/${facSel.COD}/anular`);
    cargar(); setFacSel(f=>({...f,C_ESTADO:'ANL'}));
  };

  return (
    <>
      <style>{css}</style>
      <div className="fade-up">
        <div className="fac-wrap">
          {/* Lista */}
          <div className="fac-lista">
            <div className="fac-hdr">
              <span>Facturas</span>
              <div style={{display:'flex',gap:6}}>
                <button className="btn btn-sm" style={{background:'rgba(255,255,255,.15)',color:'#fff',border:'none'}}
                  onClick={()=>setModalCierre(true)}>🔒 Cierre de Caja</button>
                <button className="btn btn-sm" style={{background:'#fff',color:'var(--navy)',border:'none',fontWeight:700}}
                  onClick={()=>setModal(true)}>+ Nueva</button>
              </div>
            </div>
            <div className="fac-filters">
              <div>
                <label className="form-label" style={{fontSize:10}}>Fecha</label>
                <input type="date" className="form-control" style={{fontSize:12}} value={filtros.fecha}
                  onChange={e=>{setFiltros(f=>({...f,fecha:e.target.value}));setPage(1);}} />
              </div>
              <div>
                <label className="form-label" style={{fontSize:10}}>Estado</label>
                <select className="form-control" style={{fontSize:12}} value={filtros.estado}
                  onChange={e=>{setFiltros(f=>({...f,estado:e.target.value}));setPage(1);}}>
                  <option value="">Todos</option>
                  <option value="ACT">Activa</option>
                  <option value="ANL">Anulada</option>
                </select>
              </div>
              <button className="btn btn-sm btn-primary" style={{marginTop:14}} onClick={cargar}>
                {loading?'...':'&#128269;'}
              </button>
            </div>
            <div className="fac-body">
              {facturas.length===0&&!loading&&(
                <div style={{textAlign:'center',padding:'32px 0',color:'var(--text3)'}}>Sin facturas</div>
              )}
              {facturas.map(f=>{
                const est=ESTADOS[f.C_ESTADO]||ESTADOS.ACT;
                return (
                  <div key={f.COD} className={`fac-row ${facSel?.COD===f.COD?'sel':''}`} onClick={()=>cargarDet(f.COD)}>
                    <div>
                      <div style={{fontWeight:600,fontSize:12}}>#{f.COD} — {f.RAZON_SOCIAL}</div>
                      <div style={{fontSize:10,color:'var(--text3)'}}>{f.FECHA} · {f.CAJA}</div>
                    </div>
                    <div style={{textAlign:'right'}}>
                      <div style={{fontWeight:700,fontSize:13,color:'var(--navy)'}}>{fmt(f.TOTAL)}</div>
                      <span style={{background:est.bg,color:est.fg,padding:'1px 5px',borderRadius:3,fontSize:9,fontWeight:600}}>{est.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
            {total>30&&(
              <div style={{padding:'7px 12px',borderTop:'1px solid var(--border)',display:'flex',gap:6,justifyContent:'center'}}>
                <button className="btn btn-sm" disabled={page===1} onClick={()=>setPage(p=>p-1)}>&#8249;</button>
                <span style={{fontSize:12,padding:'4px 8px'}}>{page}</span>
                <button className="btn btn-sm" disabled={page*30>=total} onClick={()=>setPage(p=>p+1)}>&#8250;</button>
              </div>
            )}
          </div>

          {/* Detalle */}
          <DetalleFactura fac={facSel} onAnular={anular} onNueva={()=>{setFacSel(null);setModal(true);}} onRefresh={cargarDet} />
        </div>

        {modal&&(
          <ModalFactura
            turno={turnoUrl}
            cajas={cajas} formasPago={formasPago} servicios={servicios}
            ivaGlobal={ivaGlobal}
            onGuardar={()=>{setModal(false);setTurnoUrl(null);cargar();}}
            onCerrar={()=>{setModal(false);setTurnoUrl(null);}}
          />
        )}
        {modalCierre&&(
          <ModalCierreCaja cajas={cajas} onCerrar={()=>setModalCierre(false)} />
        )}
      </div>
    </>
  );
}
